@if (displayedGenerators().items) {
  <div class="flex flex-col bg-neutral-900/20 rounded-lg px-4 py-2 gap-2 text-xs">
    <div class="text-neutral-300">
      I found {{ displayedGenerators().count }}
      <span class="font-bold text-white">{{ displayedGenerators().label }}</span> that can be
      generated:
    </div>

    <div class="flex flex-col gap-1">
      @for (generator of displayedGenerators().items; track $index) {
        <div class="flex flex-row bg-black/30 gap-1 p-2 rounded-lg">
          <div class="text-white">{{ $index + 1 }}.</div>
          <div class="flex flex-col gap-1 items-start">
            <div class="text-white font-bold">{{ generator.name }}</div>
            <div
              #generatorDescription
              [class.line-clamp-none]="generator.expandedDescription"
              class="relative text-neutral-200 text-[10px] line-clamp-3"
            >
              <span>{{ generator.description }}</span>

              @if (isMultiLineOverflows(generatorDescription)) {
                <button
                  (click)="generator.expandedDescription = true"
                  class="text-white font-semibold absolute bottom-0 right-0"
                >
                  More
                </button>
              }
            </div>
            <button
              [disabled]="isGenerateFromDocumentContextDisabled()"
              (click)="generateFromDocument(generator)"
              class="font-semibold text-yellow-500"
            >
              <span>Generate This</span>
            </button>
          </div>
        </div>
      }
    </div>

    @if (!isExpandedGenerators()) {
      <button (click)="showAllGenerators()">Show All ({{ displayedGenerators().count }})</button>
    }
  </div>
} @else {
  <div class="text-neutral-300 italic text-xs">
    I didn’t find any process, so I would need more details about what you want to generate. I will
    still take into account the information from the file.
  </div>
}
